import { useGreeterVenueApi } from "@greeter/matter";
import { EditTicketEventPage } from "./EditTicketEventPage";
import { EditTicketEventParams, Routes } from "@greeter-venue/utility/Routes";
import { useRouteMatch } from "react-router-dom";

export function EditTicketEventPageApiHandler() {
  const { api } = useGreeterVenueApi();
  const m = useRouteMatch<EditTicketEventParams>(
    Routes.mainGroup.editTicketEvent.template()
  );
  return <EditTicketEventPage api={api} id={m?.params.id} />;
}
